import { EfficiencyTrackerCriteria } from "@app/types/dashboard/cards/efficiencyTracker/EfficiencyTrackerCardConfiguration";
import EntityTypesSupportedInEfficiencyTracker from "@app/types/dashboard/cards/efficiencyTracker/EntityTypesSupportedInEfficiencyTracker";

const PREFIX = "dashboard/efficiencyTracker";

const getEfficiencyDrillDownViewStateKey = (
  criteria: Pick<EfficiencyTrackerCriteria, "fieldType">,
  entityType: EntityTypesSupportedInEfficiencyTracker
): string => {
  switch (criteria.fieldType) {
    case "facetime":
      return `${PREFIX}/facetime`;
    case "wonRevenue":
      return `${PREFIX}/wonRevenue`;
    case "custom":
      return `${PREFIX}/field/${entityType}`;
    default:
      return `${PREFIX}/count/${entityType}`;
  }
};

export default getEfficiencyDrillDownViewStateKey;
